import { render } from "./App.vue?vue&type=template&id=1396aac1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1396aac1&lang=css"

import exportComponent from "/home/kadek/belajar/kadek-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__